import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    margin: '3rem',
    paddingTop: '3rem',

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      margin: '2rem 1rem'
    }
  },

  logo: {
    width: '100%',
    height: '3rem'
  },

  title: {
    fontSize: theme.size.xl,
    color: 'white'
  }
}))

const Logo = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img src='/imgs/new-logo.svg' alt='Logo' className={classes.logo} />
    </div>
  )
}

export default Logo
